import { render, staticRenderFns } from "./MandatListBulk.vue?vue&type=template&id=323e782e&scoped=true&"
import script from "./MandatListBulk.vue?vue&type=script&lang=js&"
export * from "./MandatListBulk.vue?vue&type=script&lang=js&"
import style0 from "./MandatListBulk.vue?vue&type=style&index=0&id=323e782e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e782e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('323e782e')) {
      api.createRecord('323e782e', component.options)
    } else {
      api.reload('323e782e', component.options)
    }
    module.hot.accept("./MandatListBulk.vue?vue&type=template&id=323e782e&scoped=true&", function () {
      api.rerender('323e782e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/MandatListBulk.vue"
export default component.exports